import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  GENERAL_SECTION_ID,
  InstructionPage,
  InstructionSection,
  findInstructionPage,
  instructionTitleKey,
  pagesInSection,
  sectionColumns,
  sectionsWithPages
} from '../instruction-catalog';

/**
 * The all-instructions menu: sections on the left, the chosen section's
 * pages in two columns on the right, sub-pages indented under their parent.
 * Picking a section only changes the right column; picking a page emits it.
 */
@Component({
  selector: 'app-help-menu-panel',
  templateUrl: './help-menu-panel.component.html',
  styleUrls: ['./help-menu-panel.component.scss'],
  imports: [TranslatePipe, NgTemplateOutlet]
})
export class HelpMenuPanelComponent implements OnChanges {
  /** The page open in the dialog, marked in the menu. */
  @Input() currentSlug = '';

  /** Section shown when the menu opens; defaults to the current page's. */
  @Input() section = '';

  @Output() pageSelected = new EventEmitter<string>();

  private translateService = inject(TranslateService);

  readonly sections = sectionsWithPages();
  readonly generalSection = this.sections.find(
    (s) => s.id === GENERAL_SECTION_ID
  );
  readonly viewSections = this.sections.filter(
    (s) => s.id !== GENERAL_SECTION_ID
  );

  selected = '';
  columns: InstructionPage[][][] = [];

  ngOnChanges(): void {
    const sectionId =
      this.section ||
      findInstructionPage(this.currentSlug)?.section ||
      this.sections[0]?.id;
    this.select(sectionId);
  }

  select(sectionId: string): void {
    this.selected = sectionId;
    this.columns = sectionColumns(sectionId);
  }

  count(sectionId: string): number {
    return pagesInSection(sectionId).length;
  }

  label(section: InstructionSection | undefined): string {
    return section ? this.translateService.instant(section.labelKey) : '';
  }

  get selectedSection(): InstructionSection | undefined {
    return this.sections.find((s) => s.id === this.selected);
  }

  title(slug: string): string {
    return this.translateService.instant(instructionTitleKey(slug));
  }
}
